export const ROLES_UPDATE_LIST = 'ROLES_UPDATE_LIST'
export const ROLES_UPDATE_LIST_METHOD = 'ROLES_UPDATE_LIST_METHOD'

export const updateList = (list = []) => ({
  type: ROLES_UPDATE_LIST,
  payload: { list }
})

export const updateListMethod = (method = 'POST', data) => ({
  type: ROLES_UPDATE_LIST_METHOD,
  payload: { method, data }
})

